import React from 'react';

import { Stack, StackProps } from '@mui/material';

import { Body } from './Body';
import { Container } from './Container';
import { ContainerH, ContainerV } from './Container/Container';
import { Header } from './Header';

const LookoPageMenuContainer = React.forwardRef<HTMLDivElement, StackProps>((props, ref) => (
  <Stack ref={ref} width="100%" height={'100%'} component={'main'} position={'relative'} {...props} />
));
/**
 * 페이지 스타일의 메뉴 구성 시, 디자인 아나토미.
 */
export const LookoPageMenu = Object.assign(LookoPageMenuContainer, {
  /**
   * 메뉴의 헤더.
   */
  Header: Header,

  /**
   * 메뉴의 바디.
   */
  Body: Body,

  /**
   * 바디 안의 컨테이너들.
   */
  ContainerH: ContainerH,
  ContainerV: ContainerV,

  /**
   * 컨테이너 안 컨텐츠들.
   */
  Container: Container,
});
